import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const PreviewCompatibleImage = ({
  imageInfo,
  style,
  className,
  placeholder = "blurred",
  loading = "lazy",
  ...props
}) => {
  const imageStyle = { maxWidth: "100%", ...style }

  if (typeof imageInfo === "string") {
    return (
      <img
        className={className}
        style={imageStyle}
        src={imageInfo}
        {...props}
      />
    )
  }

  const { alt = "", childImageSharp, image } = imageInfo

  if (image && image.childImageSharp) {
    return (
      <GatsbyImage
        image={image.childImageSharp.gatsbyImageData}
        imgStyle={imageStyle}
        alt={alt}
        className={className}
        placeholder={placeholder}
        loading={loading}
        {...props}
      />
    )
  } else if (childImageSharp) {
    return (
      <GatsbyImage
        image={childImageSharp.gatsbyImageData}
        imgStyle={imageStyle}
        alt={alt}
        className={className}
        placeholder={placeholder}
        loading={loading}
        {...props}
      />
    )
    // SVGs
  } else if (imageInfo.publicURL) {
    return (
      <img
        src={imageInfo.publicURL}
        className={className}
        alt={alt}
        style={imageStyle}
      />
    )
  } else if (image.publicURL) {
    return (
      <img
        src={image.publicURL}
        className={className}
        alt={alt}
        style={imageStyle}
      />
    )
    // for Netlify CMS
  } else if (typeof image === "string") {
    return (
      <img style={imageStyle} src={image} alt={alt} className={className} />
    )
  } else {
    console.warn("No image returned from PreviewCompatibleImage")
    return null
  }
}

export default PreviewCompatibleImage
